import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Mail, CheckCircle } from 'lucide-react';
import { SectionReveal } from '../ui/SectionReveal';
import { CTAButton } from '../ui/CTAButton';
export function OfferSection() {
  return <SectionReveal bgColor="dark" id="offer-section" className="relative" data-id="element-120">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full max-h-[500px] bg-[#0D6E6E] opacity-20 blur-[100px] rounded-full pointer-events-none" data-id="element-121" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-122">
        {/* Proof / Believability */}
        <div className="text-center mb-16" data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-6" data-id="element-124">
            Qué cambia en <span className="text-[#D4A017]" data-id="element-125">7 días</span>:
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-126">
            No prometemos milagros, prometemos datos. Al séptimo día, no solo
            verás números más bajos y estables en tu glucómetro, sino que
            sentirás un aumento en tu energía vital y la tranquilidad de saber
            que{' '}
            <strong className="text-white" data-id="element-127">
              tú tienes el mando, no la enfermedad.
            </strong>
          </p>
        </div>

        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        type: 'spring'
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl shadow-black/50 max-w-2xl mx-auto border-4 border-[#0D6E6E]/20 relative" data-id="element-128">
          {/* Badge */}
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-[#D4A017] text-[#1A1A2E] font-extrabold px-6 py-2 rounded-full shadow-lg text-sm uppercase tracking-wider" data-id="element-129">
            Oferta Especial
          </div>

          <div className="text-center mb-8 pt-4" data-id="element-130">
            <h3 className="text-2xl font-bold text-[#1A1A2E] mb-2" data-id="element-131">
              Plan 7D Control Completo
            </h3>
            <p className="text-gray-500 mb-6" data-id="element-132">
              Acceso digital instantáneo a todo el material
            </p>

            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-133">
              <span className="text-gray-400 line-through text-2xl font-medium" data-id="element-134">
                $19 USD
              </span>
              <span className="text-5xl md:text-6xl font-extrabold text-[#0D6E6E]" data-id="element-135">
                $8.99 <span className="text-2xl" data-id="element-136">USD</span>
              </span>
            </div>

            <ul className="text-left space-y-4 mb-10 max-w-md mx-auto" data-id="element-137">
              {['Guía Maestra PDF', 'Plan de Suplementación', 'Método Orden de Alimentos', 'Protocolo de Rescate'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700 font-medium" data-id="element-138">
                  <CheckCircle className="w-5 h-5 text-[#10B981] shrink-0" data-id="element-139" />
                  {item}
                </li>)}
            </ul>

            <CTAButton fullWidth className="py-5 text-xl shadow-xl" data-id="element-140">
              ¡SÍ, QUIERO EMPEZAR MIS 7 DÍAS DE CONTROL!
            </CTAButton>
            <p className="text-sm text-gray-500 mt-4 font-medium" data-id="element-141">
              Haz clic arriba para descargar la guía ahora
            </p>
          </div>

          {/* Trust Indicators */}
          <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-142">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-gray-600 font-medium" data-id="element-143">
              <div className="flex items-center gap-2" data-id="element-144">
                <Lock className="w-5 h-5 text-[#0D6E6E]" data-id="element-145" />
                <span data-id="element-146">Compra 100% Segura</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-147">
                <Mail className="w-5 h-5 text-[#0D6E6E]" data-id="element-148" />
                <span data-id="element-149">Entrega Inmediata vía Email</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-150">
                <Shield className="w-5 h-5 text-[#0D6E6E]" data-id="element-151" />
                <span data-id="element-152">Garantía de Satisfacción</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </SectionReveal>;
}